import { get, post } from '@/utils/ajax'

/**
 *
 * @param {object} params
 * @param {string|number} params.userId
 * @param {string|number} params.examId
 * @param {number} params.type 1: 获取电脑摄像头token 2: 获取手机端token
 * @param {number?} params.uid 唯一uid 不传则随机生成
 * @param {string} params.TIME
 * @returns {Promise<{appId: string;channel: string; token: string; uid: string}>}
 */
export function getAgoraToken(params) {
  return get(`/home/ai-invigilate/agora-token`, params)
}

/**
 *
 * @param {object} params
 * @param {string|number} params.userId
 * @param {string|number} params.examId
 * @param {number} params.type 1: 获取电脑摄像头token 2: 获取手机端token
 * @param {string} params.TIME
 * @returns {Promise<{appId: string;channel: string; token: string; uid: string}>}
 */
export function getAgoraTokenWithUniqueUID(params) {
  return get(`/home/ai-invigilate/agora-token-fixed-uid`, params)
}

/**
 *
 * @param {string} appid
 * @param {string} examId
 * @returns {Promise<{key: string}>}
 */
export function getMiniAppAccessToken(appid, examId) {
  return post(`/home/auth/createMiniToken`, {
    appid,
    examId,
    type: 2
  })
}

/**
 * 开始云端录制
 * @param {object} params
 * @param {string} params.examId
 * @param {string} params.userId
 * @param {number} params.type 1: 电脑端 2: 小程序端
 * @returns {Promise<{status: number; recordUid: number; channel: string; type: number; resourceId: string; sid: string;}>}
 * status: 状态码: 0：没有开始云端录制。1：云端录制初始化完成。2：录制组件开始启动。3：上传组件启动完成。4：录制组件启动完成。5：已成功上传第一个文件。第一个文件上传完成后，录制在进行中均会返回此状态。6：已经停止录制。7：云端录制服务全部停止。8：云端录制准备退出。20：云端录制异常退出。
 */
export function startExamRecording(params) {
  return get(`/home/ai-invigilate/start-agora-record`, {
    ...params,
    TIME: new Date().getTime()
  })
}

/**
 *
 * @param {object} params
 * @param {string} params.examId
 * @param {string} params.userId
 * @param {number} params.type 1: 电脑端 2: 小程序端
 * @param {string} params.recordUid
 * @param {string} params.channel
 * @param {string} params.resourceId
 * @param {string} params.sid
 * @returns {Promise<{status: number; fileList: string; type: number; sliceStartTime: string;}>}
 */
export function getExamRecordingInfos(params) {
  return post(`/home/ai-invigilate/get-agora-record`, params)
}

/**
 *
 * @param {object} params
 * @param {string} params.channel
 * @param {string} params.recordUid
 * @param {string} params.resourceId
 * @param {string} params.sid
 * @returns
 */
export function stopExamRecording(params) {
  return post(`/home/ai-invigilate/stop-agora-record`, params)
}
